const initState = {};

export const reducer = (state = initState, { type, payload }) => {
  switch (type) {
    default:
      return state;
  }
};
